import { render, staticRenderFns } from "./DoQuiz.vue?vue&type=template&id=e4c5669c&scoped=true"
import script from "./DoQuiz.vue?vue&type=script&lang=js"
export * from "./DoQuiz.vue?vue&type=script&lang=js"
import style0 from "./DoQuiz.vue?vue&type=style&index=0&id=e4c5669c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c5669c",
  null
  
)

export default component.exports